var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#757575",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56234 12.4385C9.39175 12.4385 9.22098 12.3722 9.09098 12.2419L9.03369 12.1846C8.77303 11.9239 8.77303 11.5019 9.03369 11.2419L11.6092 8.66638H2.89569C2.52766 8.66638 2.22899 8.36771 2.22899 8.00071C2.22899 7.63271 2.52766 7.33405 2.89569 7.33405H11.6092L9.03369 4.75854C8.77303 4.49787 8.77303 4.07583 9.03369 3.81583L9.09098 3.75854C9.35164 3.49787 9.77369 3.49787 10.0337 3.75854L13.8045 7.52939C14.0652 7.79006 14.0652 8.2121 13.8045 8.4721L10.0337 12.2429C9.90336 12.3732 9.73292 12.4395 9.56234 12.4395Z",
    fill: "#757575"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIconSearch);
export default __webpack_public_path__ + "static/media/rightIconSearch.794e8b45145f0711341abeeab6b5e8b0.svg";
export { ForwardRef as ReactComponent };